/*
* @Author: gujianghua
* @Date:   2019-11-11 19:00:41
* @Last Modified by:   gujianghua
* @Last Modified time: 2019-11-14 19:06:43
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	// 课程列表
	getList(params) {
		return service({
		  url: '/cloud/course/v1/admin/course/statistic/getCourseDataList',
		  method: 'get',
		  params: params
		})    
	},
	// 浏览医生图表
	getCourseChartViewData(params) {
		return service({
		  url: '/cloud/course/v1/admin/course/statistic/getCourseChartViewData',
		  method: 'get',
		  params: params
		})    
	},
	// 浏览医生列表
	getCourseViewUserList(params) {
		return service({
		  url: '/cloud/course/v1/admin/course/statistic/getCourseViewUserList',
		  method: 'get',
		  params: params
		})    
	},
	// 加入医生图表
	getCourseChartJoinData(params) {
		return service({
		  url: '/cloud/course/v1/admin/course/statistic/getCourseChartJoinData',
		  method: 'get',
		  params: params
		})    
	},
	// 加入医生列表
	getCourseJoinUserList(params) {
		return service({
		  url: '/cloud/course/v1/admin/course/statistic/getCourseJoinUserList',
		  method: 'get',
		  params: params
		})    
	},
	/**
	* [export 导出]
	* @param  {[obj]} data [筛选条件]
	* @return {[obj]}
	*/
	exportViewUserList(data) {
	    let url = v2 + '/cloud/course/v1/admin/course/statistic/exportViewUserList?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
	/**
	* [export 导出]
	* @param  {[obj]} data [筛选条件]
	* @return {[obj]}
	*/
	exportJoinUserList(data) {
	    let url = v2 + '/cloud/course/v1/admin/course/statistic/exportJoinUserList?' +
	      searchParamsFormatter(data)
	    window.location.href = url
	},
}


// WEBPACK FOOTER //
// ./src/api/databaseAnlysis/viewdataAnalysis.js